export default __webpack_public_path__ + "static/media/desarrollo-web.14fffda1.svg";